import React from "react";
import { Space, Row, Col, Divider, Typography } from "antd";

const { Title } = Typography;

function TitledSection(props) {
    const titleExtraLength = props.titleExtra && Object.keys(props.titleExtra).length === 0 // check the length of titleExtra props
    return (
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
            {(props.title || props.titleExtra) &&
                <>
                    <Row justify={props.title ? "space-between" : "end"}>
                        {props.title &&
                            <Col>
                                <Title level={props.titleLevel || 3}>
                                    {props.title}
                                </Title>
                            </Col>}
                        {(props.titleExtra && !titleExtraLength) &&
                            <Col>
                                <Row>
                                    <Col>
                                        {props.title && <Divider type="vertical" style={{ height: "100%" }} />}
                                    </Col>
                                    <Col>
                                        {props.titleExtra}
                                    </Col>
                                </Row>
                            </Col>}
                    </Row>
                    {props.isDivider && <Divider style={{
                        margin: "0px",
                        marginTop: props.dividerMargin ? `${props.dividerMargin}px` : "0px",
                    }} />}
                </>
            }
            <Row>
                {props.body}
            </Row>

        </Space>
    )
}


export default TitledSection;